<template>
  <div>
    <a-skeleton :loading="isloading" active>
      <div>
        <a-row class="orderInfo_marB">
          <a-col :span="12">
            订单编号
            <span class="font-color">{{ info.id }}</span>
          </a-col>
          <a-col :span="12">
            订单状态
            <span class="font-color" v-if="info.orderStatus == 1">待支付</span>
            <span class="font-color" v-else-if="info.orderStatus == 2">待发货</span>
            <span class="font-color" v-else-if="info.orderStatus == 3">待收货</span>
            <span class="font-color" v-else-if="info.orderStatus == 4">待评价</span>
            <span class="font-color" v-else-if="info.orderStatus == 5">已完成</span>
            <span class="font-color" v-else-if="info.orderStatus == 6">已取消</span>
            <span class="font-color" v-else>已退款</span>
          </a-col>
        </a-row>
        <a-row class="orderInfo_marB">
          <a-col :span="12">
            订单总金额
            <span class="font-color">
              ￥{{ info.totalprice }}
            </span>
          </a-col>
          <a-col :span="12">
            支付金额
            <span class="font-color">￥{{ info.payprice }}</span>
          </a-col>
        </a-row>
        <a-row class="orderInfo_marB">
          <a-col :span="12">
            折扣%
            <span class="font-color">{{ Number(info.discount) > 0 && Number(info.discount) < 100 ? Number(info.discount)
              + "%" : "无折扣" }}</span>
          </a-col>
           <a-col :span="12" class="order_remark">
            备注:
            <span class="font-color">{{ info.remark }}</span>
          </a-col>
        </a-row>
        <a-divider orientation="left">订单信息</a-divider>
        <a-row class="orderInfo_marB">
          <a-col :span="12">
            买家信息
            <span class="font-color">{{ info.telephone }} {{ info.userName }}</span>
          </a-col>
          <a-col :span="12">
            支付方式
            <span class="font-color">
              <a-tag v-for="(item, index) in baseConfig.pay_method_line" v-if="item.label == info.paymentMethod"
                :color="item.color">{{ item.title }}</a-tag>
            </span>
          </a-col>
        </a-row>
        <a-row class="orderInfo_marB">
          <a-col :span="12">
            下单时间
            <span class="font-color">{{ info.addtime }}</span>
          </a-col>
          <a-col :span="12" v-if="info.orderStatus >= 5">
            支付时间
            <span class="font-color">{{ info.paytime }}</span>
          </a-col>
          <a-col :span="12"></a-col>
        </a-row>
        <a-row class="orderInfo_marB">
          <a-col :span="12">
            三方交易单号
            <span class="font-color">{{ info.orderStatus == 5 || info.orderStatus == 7 ? info.transaction_id : "" }}</span>
          </a-col>
          <a-col :span="12">
            单位名称
            <span class="font-color">{{ info.company }}</span>
          </a-col>
        </a-row>
        <a-row class="orderInfo_marB">
          
          <a-col :span="12" v-if="info.orderStatus == 7">
            退款时间
            <span class="font-color">{{ info.refund_time }}</span>
          </a-col>
        </a-row>
      </div>
    </a-skeleton>
    <a-divider orientation="left">商品信息</a-divider>
    <a-table :columns="list.columns" rowKey="id" :pagination="false" :dataSource="list.datas" :loading="isloading"
      :locale="{ emptyText: '暂无数据' }">
      <span slot="headUrl" slot-scope="headUrl">
        <a-avatar :src="headUrl" />
      </span>

        <span slot="is_deleted" slot-scope="is_deleted">
          <a-tag v-if="is_refund == 1" color="red">已退款</a-tag>
          <a-tag v-if="is_refund == 0 && is_deleted == 1" color="red">已移除 </a-tag>
          <a-tag v-else color="green">正常</a-tag>
        </span>

      <span slot="action" slot-scope="action">
        {{ action.buyPrice * action.count }}
      </span>
    </a-table>
  </div>
</template>

<script>
const columns = [
  {
    dataIndex: "productName",
    key: "productName",
    align: "center",
    title: "课程名称"
  },
  {
    dataIndex: "type_name",
    key: "type_name",
    align: "center",
    title: "课程分类"
  },
  {
    dataIndex: "buyPrice",
    key: "buyPrice",
    align: "center",
    title: "价格"
  },
  {
    dataIndex: "hour_count",
    key: "hour_count",
    align: "center",
    title: "学时"
  },
  {
    dataIndex: "year",
    key: "year",
    align: "center",
    title: "年份"
  },
  {
    dataIndex: "is_deleted",
    key: "is_deleted",
    align: "center",
    title: "课程状态",
    scopedSlots: { customRender: "is_deleted" }
  },
  {
    dataIndex: "delete_time",
    key: "delete_time",
    align: "center",
    title: "退款/移除时间",
    scopedSlots: { customRender: "op" }
  },
];


var that;

export default {
  props: {
    infos: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 999999 //页容
        }
      },
      info: {
        postage: 123,
      },
      isloading: false,
      loadingTip: "加载中...",
      baseConfig: {
        //列表 支付方式
        pay_method_line: []
      },
    };
  },
  mounted() {
    this.$nextTick(function () {
      that = this;
      this.orderInfo();
      this.getBaseConfig();
    });
  },
  methods: {
    getBaseConfig() {
      var params = {
        configList: ['pay_method_line']
      }
      this.$api.baseConfig.getBaseConfig(params).then(
        res => {
          if (res.errorCode == that.$msg.responseCode.success) {
            this.baseConfig = res.data;
          } else {
            this.error(res.errorMsg);
          }
        }
      );
    },
    closeLoading() {
      this.isloading = false;
    },
    orderInfo() {
      this.isloading = true;
      this.$api.order
        .ogetById(this.infos.id)
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.info = res.data.order;
            this.list.datas = res.data.order.orderitemList;
          } else {
            this.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
          this.error();
        });
    },
    error(msg) {
      this.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        }
      });
    }
  }
};
</script>
<style>
.font-color {
  color: #999;
  margin-left: 10px;
}

.orderInfo_marB {
  margin-bottom: 15px;
  line-height: 32px;
}

.orderInfo_marB input,
.ant-input-group-wrapper {
  width: 60%;
}

.icon_rg {
  margin-left: 10px;
}
</style>
  